import { createContext } from "react";

export const IsMobileViewContext = createContext(false);
